import React from "react";
import { NavLink } from "react-router-dom";
import CustomButton from "../shared/CustomButton";

const BonusPointsLayout = ({ children, onOpenAddForm }) => {
  return (
    <div className="bonus-points-layout">
      <div className="bonus-points-layout-header">
        <h4 className="bonus-points-layout-header-title">Atribuição de pontos</h4>
      </div>
      <div className="bonus-points-layout-container">
        <nav className="bonus-points-layout-navigation">
          <NavLink
            exact
            to="/bonus_points"
            activeClassName="bonus-points-layout-navigation-item-active"
            className="bonus-points-layout-navigation-item"
          >
            Extrato
          </NavLink>
          <NavLink
            exact
            to="/bonus_points/history"
            activeClassName="bonus-points-layout-navigation-item-active"
            className="bonus-points-layout-navigation-item"
          >
            Pontos atribuidos
          </NavLink>
        </nav>
        {children}
      </div>
      <div className="bonus-points-layout-actions">
        <CustomButton secondary onClick={onOpenAddForm}>
          Atribuir Pontos
        </CustomButton>
      </div>

    </div>
  );
};

export default BonusPointsLayout;
